import { buildSectionUpdate } from '@griply/services';
import { useUpdateLifeArea } from 'features/life-areas';
import { useLifeAreaById } from 'features/life-areas/hooks/use-life-area-by-id';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';
import { v4 as uuidv4 } from 'uuid';

export const useCreateLifeAreaSection = (lifeAreaId?: ID) => {
  const lifeArea = useLifeAreaById(lifeAreaId);
  const { submit: updateLifeArea } = useUpdateLifeArea();

  return useCallback(() => {
    if (!lifeArea?.id) {
      return;
    }

    updateLifeArea(
      buildSectionUpdate(lifeArea, {
        id: uuidv4(),
        name: '',
        createdAt: new Date(),
      }),
    );
  }, [lifeArea, updateLifeArea]);
};
